<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div class="dialog--content dialog--extended-width u-extra-medium-padding--bottom">
      <h4 class="u-extra-small-margin--bottom">{{ $t('search.project.title') }}</h4>
      <p>{{ $t('search.project.intro') }}</p>
      <div class="grid-x grid-margin-x">
        <div class="cell small-auto medium-8">
          <input type="text" v-model="project_number" :placeholder="$t('search.project_number')" />
        </div>
        <div class="cell small-auto medium-4">
          <button class="button" @click.prevent="projectSearch">{{ $t('search') }}</button>
        </div>
        <div class="cell auto">
          <v-table
            class="c-tourplan-table u-extra-small-margin--top"
            :isLoading="projectsTableLoading"
            :columns="projectsTableColumns"
            :items="projectsTableItems"
            :showHeaderRow="true"
            :showShowAll="false"
            :useDetailRow="false"
          >
            <template slot="project_number" slot-scope="{ row }">
              <span v-if="row.project_number">
                <strong>{{ row.project_number }}</strong>
              </span>
              <div v-if="projectHasRoute(row)" class="callout alert u-text-center">
                <div v-for="(route, index) in row.tour_routes" :key="index">
                  <router-link
                    :to="{ name : 'update-tour', params: {tour: route.tour_id} }"
                    class="u-no-margin"
                    :title="$t('update')"
                  >{{ route.tour_number }}</router-link>
                </div>
              </div>
            </template>

            <template slot="company_name" slot-scope="{ row }">
              <p
                class="u-no-margin c-tourplan-table__company-name"
                v-if="row.customer"
              >{{ row.customer.company_name }}</p>

              <p
                class="u-no-margin"
                v-if="row.account"
              >{{ row.account.profile.firstname }} {{ row.account.profile.lastname }}</p>
            </template>

            <template slot="address" slot-scope="{ row }">
              <p class="u-no-margin">
                <strong>{{ row.address.zipcode }} {{ row.address.city }}</strong>
                <br />
                {{ row.address.street }} {{ row.address.housenumber }}
              </p>
            </template>
            <template slot="layers" slot-scope="{ row }" v-if="row.layers">
              <p class="u-no-margin" v-for="(layer, index) in row.layers" :key="index">
                <strong>{{ layer.subtype }}</strong>
              </p>
            </template>

            <template slot="openqm" slot-scope="{ row }" v-if="row.stats">
              <p>{{ row.stats.qm.open }} / {{ row.stats.qm.total }}</p>
            </template>
            <template slot="action" slot-scope="{ row }">
              <div v-if="!row.alreadyInSearchResult">
                <button
                  class="button secondary"
                  @click.prevent="selectProject(row)"
                >{{ $t('tours.addproject') }}</button>
              </div>
              <p class="u-error" v-else>{{ $t('tours.error.hasmatch') }}</p>
            </template>
          </v-table>
        </div>
      </div>

      <button class="close-button" @click.prevent="onCloseDialog">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import Table from "./../partials/Foundation/Table";
export default {
  name: "ProjectSearchModal",
  components: {
    vTable: Table
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    currentSearchResults: {
      type: Array,
      default: () => {}
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {
      projectsTableLoading: false,
      projectsTableItems: [],
      projectsTableColumns: [
        {
          key: "project_number",
          label: this.$t("weeks.project.number"),
          width: "180px"
        },
        {
          key: "company_name",
          label: this.$t("tours.companyname"),
          width: "150px"
        },
        {
          key: "address",
          label: this.$t("weeks.project.address"),
          width: "180px"
        },
        {
          key: "layers",
          label: this.$t("weeks.project.layers"),
          width: "180px"
        },
        {
          key: "openqm",
          label: this.$t("weeks.project.openqm"),
          width: "130px"
        },
        { key: "action" }
      ],
      result: null,
      project_number: null
    };
  },

  computed: {
    showDialog: {
      get: function() {
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    },

    showErrorTourNumber: function() {
      return this.errorTourNumber;
    }
  },
  methods: {
    projectHasRoute: function(project) {
      return project && project.tour_routes && project.tour_routes.length > 0;
    },

    onCloseDialog: function() {
      this.showDialog = false;
      this.resetValues();
    },

    resetValues: function() {
      this.errorTourNumber = "";
      this.hasTour = false;
      this.hasMatch = false;
      this.projectsTableItems = [];
    },

    selectProject: function(project) {
      this.$emit("addProject", project);
      this.resetValues();
    },

    checkProjects: function(searchResult) {
      let sendResults = [];

      searchResult.forEach(item1 => {
        for (let item2 of this.currentSearchResults) {
          if (parseInt(item1.id) === parseInt(item2.id)) {
            item1["alreadyInSearchResult"] = true;
            break;
          } else {
            item1["alreadyInSearchResult"] = false;
          }
        }
      });

      this.projectsTableItems = searchResult;
    },

    projectSearch: function() {
      this.projectsTableLoading = true;

      let promise = this.$api
        .clearParams()
        .addParam("search", this.project_number)
        .setSortParams("createdon", "desc")
        .get("projects");

      promise
        .then(
          (response => {
            let result = response.data.data;
            this.checkProjects(result);
          }).bind(this)
        )
        .catch(
          (error => {
            this.projectsTableItems = [];
          }).bind(this)
        )
        .finally(
          (() => {
            this.projectsTableLoading = false;
          }).bind(this)
        );
    }
  }
};
</script>